<div class="grid-dayview">
  <div class="cell-toolbar">
    <cst-toolbar>
      <ctrl-btn i18n-content="@@scheduler_today" i18n-title="@@scheduler_today" content="Today" title="Today"
      (click)="SetReferenceDateToToday()" [flat]="true"></ctrl-btn>
      <ctrl-btn (click)="SetReferenceDateToPrevious()" i18n-title="@@scheduler_previous" title="Previous" [flat]="true"
      icon="chevron_left" [spamClickDelayMS]="0"></ctrl-btn>
      <ctrl-btn (click)="SetReferenceDateToNext()" i18n-title="@@scheduler_next" title="Next" [flat]="true"
      icon="chevron_right" [spamClickDelayMS]="0"></ctrl-btn>
      <ctrl-btn (click)="ToggleCalendarPopup($event)" [content]="overview.uiState.ReferenceDate | date: 'MMMM yyyy'"
      [flat]="true" icon="event" #datePopupAnchor></ctrl-btn>
    </cst-toolbar>
  </div>
  <div class="cell-list">
    <app-planung-number-tasks-collection [overview]="overview" [items]="overview.TasksDays">
    </app-planung-number-tasks-collection>
  </div>

  <div id="date-picker-wrapper">
    @if (showDatePopUp) {
      <frm-date-picker [(ngModel)]="overview.uiState.ReferenceDate" id="date-picker" (valueChange)="showDatePopUp = false"></frm-date-picker>
    }
  </div>
</div>